import BaseService from '@/ecm/common/BaseService.js'
import Utils from '@/ecm/common/Utils.js'

class DocumentLifecycleService {
  baseUrl = 'document-lifecycle';

  getGrid = () => Utils.grid.getParameters(`${this.baseUrl}/get-grid`);
  delete = (id) => BaseService.post({ url: `${this.baseUrl}/delete/${id}` });
  save = (document) => BaseService.post({ url: `${this.baseUrl}/save`, data: document });
}

export default new DocumentLifecycleService()
